import { RecognitionItem } from 'lib/nmdpconnect';
import { getEnumValue } from 'lib/util/enum';
import { classnames } from 'tailwindcss-classnames';

const Category = (item: RecognitionItem) => {
  const {
    fields: { recognitionCategory },
  } = item;
  const categoryName = getEnumValue(recognitionCategory);
  const categoryStyle = classnames(
    'font-semibold',
    'text-center',
    {
      'bg-dayglow': categoryName === 'Makes the Impossible Possible',
      'bg-gray-whisper': categoryName === 'Builds Great Teams',
      'bg-plum': categoryName === 'Employees Always',
      'bg-orange': categoryName === 'Innovation',
      'bg-blue-night': categoryName === 'Results Driven',
    },
    {
      'text-solidBlack':
        categoryName === 'Innovation' || categoryName === 'Makes the Impossible Possible',
      'text-white': categoryName === 'Employees Always' || categoryName === 'Results Driven',
    },
    'p-2',
    'text-body'
  );
  return <div className={categoryStyle}>{categoryName}</div>;
};

export default Category;
